/* eslint-disable */
import { PRODUCT_NAMES, SERUM_USAGES, PRODUCT_CATEGORY } from '@/constants/treatment';

import FaceSerumPackImageCart from '@/assets/images/cart-products/face-serum-pack.jpg';
import EyeContourSerumImageCart from '@/assets/images/cart-products/eye-contour-serum.jpg';

import NexUltraO100ImageCart from '@/assets/images/cart-products/nexultra-O-100.png';
import NexUltraO200ImageCart from '@/assets/images/cart-products/nexultra-O-200.png';
import UniverskinHImageCart from '@/assets/images/cart-products/universkin-H.jpg';
import UniverskinMImageCart from '@/assets/images/cart-products/universkin-M.jpg';
import NexUltra1ImageCart from '@/assets/images/cart-products/nexultra-1.jpg';
import NexUltra2ImageCart from '@/assets/images/cart-products/nexultra-2.jpg';
import NexUltra3ImageCart from '@/assets/images/cart-products/nexultra-3.jpg';
import NexUltraB30ImageCart from '@/assets/images/cart-products/nexultra-B-30.jpg';
import NexUltraB100ImageCart from '@/assets/images/cart-products/nexultra-B-100.jpg';
import Gel30ImageCart from '@/assets/images/cart-products/gel-30.jpg';
import Gel100ImageCart from '@/assets/images/cart-products/gel-100.jpg';
import SunscreenFluidImageCart from '@/assets/images/cart-products/sunscreen-fluid.jpg';
import NexUltraL30ImageCart from '@/assets/images/cart-products/nexultra-L-30.jpg';
import NexUltraL75ImageCart from '@/assets/images/cart-products/nexultra-L-75.jpg';
import NexUltraZImageCart from '@/assets/images/cart-products/nexultra-Z.png';
import SunscreenCRMImageCart from '@/assets/images/cart-products/sunscreenCRM.jpg';
import NexUltraUVImageCart from '@/assets/images/cart-products/nexultra-UV.jpg';
import NexUltraLBrushImageCart from '@/assets/images/cart-products/nexultra-L-brush.jpg';
import NexultraPLightImageCart from '@/assets/images/cart-products/nexultra-PLight.jpg';
import NexultraPRichImageCart from '@/assets/images/cart-products/nexultra-PRich.jpg';
import FreeSampleImageCart from '@/assets/images/cart-products/free-sample.jpg';

const YOUR_ROUTINE_SUBSECTION_NAMES = PRODUCT_CATEGORY;

const YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_DEFAULT = {
  [YOUR_ROUTINE_SUBSECTION_NAMES.CLEANSE]: [PRODUCT_NAMES.NEXULTRA_O, PRODUCT_NAMES.GEL],
  [YOUR_ROUTINE_SUBSECTION_NAMES.TREAT]: [
    PRODUCT_NAMES.FACE_SERUM,
    PRODUCT_NAMES.EYE_CONTOUR_SERUM,
    PRODUCT_NAMES.UNIVERSKIN_H
  ],
  [YOUR_ROUTINE_SUBSECTION_NAMES.MOISTURIZE]: [
    PRODUCT_NAMES.UNIVERSKIN_H,
    PRODUCT_NAMES.NEXULTRA_P_LIGHT,
    PRODUCT_NAMES.NEXULTRA_P_RICH,
    PRODUCT_NAMES.NEXULTRA_B
  ],
  [YOUR_ROUTINE_SUBSECTION_NAMES.PROTECT]: [
    PRODUCT_NAMES.SUNSCREEN_SPF,
    PRODUCT_NAMES.SUNSCREEN_FLD,
    PRODUCT_NAMES.SUNSCREEN_CRM,
    PRODUCT_NAMES.NEXULTRA_UV,
    PRODUCT_NAMES.UNIVERSKIN_M
  ]
};

const CART_PRODUCT_IMAGES = {
  [PRODUCT_NAMES.FACE_SERUM]: {
    usageImages: {
      [SERUM_USAGES.MORNING_ONLY]: FaceSerumPackImageCart,
      [SERUM_USAGES.EVENING_ONLY]: FaceSerumPackImageCart,
      [SERUM_USAGES.MORNING_AND_EVENING]: FaceSerumPackImageCart,
      [SERUM_USAGES.ONE_MORNING_ONE_EVENING]: FaceSerumPackImageCart
    }
  },
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: {
    usageImages: {
      [SERUM_USAGES.MORNING_ONLY]: EyeContourSerumImageCart,
      [SERUM_USAGES.EVENING_ONLY]: EyeContourSerumImageCart,
      [SERUM_USAGES.MORNING_AND_EVENING]: EyeContourSerumImageCart
    }
  },
  [PRODUCT_NAMES.NEXULTRA_O]: {
    sizeOptionImages: { 100: NexUltraO100ImageCart, 200: NexUltraO200ImageCart }
  },
  [PRODUCT_NAMES.UNIVERSKIN_H]: {
    image: UniverskinHImageCart
  },
  [PRODUCT_NAMES.UNIVERSKIN_M]: {
    image: UniverskinMImageCart
  },
  [PRODUCT_NAMES.NEXULTRA_1]: {
    image: NexUltra1ImageCart
  },
  [PRODUCT_NAMES.NEXULTRA_2]: {
    image: NexUltra2ImageCart
  },
  [PRODUCT_NAMES.NEXULTRA_3]: {
    image: NexUltra3ImageCart
  },
  [PRODUCT_NAMES.NEXULTRA_B]: {
    sizeOptionImages: { 30: NexUltraB30ImageCart, 100: NexUltraB100ImageCart }
  },
  [PRODUCT_NAMES.NEXULTRA_L]: {
    sizeOptionImages: { 50: NexUltraL30ImageCart, 75: NexUltraL75ImageCart }
  },
  [PRODUCT_NAMES.GEL]: {
    sizeOptionImages: { 30: Gel30ImageCart, 100: Gel100ImageCart }
  },
  [PRODUCT_NAMES.SUNSCREEN_FLD]: {
    image: SunscreenFluidImageCart
  },
  [PRODUCT_NAMES.SUNSCREEN_SPF]: {
    image: NexUltraZImageCart
  },
   [PRODUCT_NAMES.SUNSCREEN_CRM]: {
    image: SunscreenCRMImageCart
  },
  [PRODUCT_NAMES.NEXULTRA_UV]: {
    subtitleRecommended: 'yourRoutine.product.yourNexultraUV.subtitle',
    image: NexUltraUVImageCart
  },
 [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: {
    image: NexultraPLightImageCart
  },
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: {
    image: NexultraPRichImageCart
  },
  [PRODUCT_NAMES.FREE_SAMPLE]: {
    image: FreeSampleImageCart
  }
};

const PRODUCTS_CONFIGURATION = {
  [PRODUCT_NAMES.FACE_SERUM]: {
    title: 'yourRoutine.product.faceSerumPack.title',
    titleRecommended: 'product.serum.packLabel',
    subtitle: 'yourRoutine.product.faceSerumPack.subtitle',
    subtitleRecommended: null,
    bottleSubtitle: 'yourRoutine.product.faceSerumPack.subtitle'
  },
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: {
    title: 'product.serum.genericEyeContourSerumLabel',
    titleRecommended: 'discover.product.serumEye.title',
    subtitle: 'yourRoutine.product.eyeContourSerum.subtitle',
    subtitleRecommended: null
  },
  [PRODUCT_NAMES.NEXULTRA_O]: {
    title: 'yourRoutine.product.nexultraO.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultraO.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourNexultraO.subtitle'
  },
  [PRODUCT_NAMES.UNIVERSKIN_H]: {
    title: 'yourRoutine.product.universkinH.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.universkinH.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourUniverskinH.subtitle'
  },
  [PRODUCT_NAMES.UNIVERSKIN_M]: {
    title: 'yourRoutine.product.universkinM.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.universkinM.subtitle',
    subtitleRecommended: 'yourRoutine.product.universkinM.subtitle'
  },
  [PRODUCT_NAMES.NEXULTRA_1]: {
    title: 'yourRoutine.product.nexultra1.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultra1.subtitle',
    subtitleRecommended: {
      [SERUM_USAGES.MORNING_ONLY]: 'yourRoutine.product.yourDayNexultra1.subtitle',
      [SERUM_USAGES.EVENING_ONLY]: 'yourRoutine.product.yourNightNexultra1.subtitle',
      [SERUM_USAGES.MORNING_AND_EVENING]: 'yourRoutine.product.yourDayAndNightNexultra1.subtitle'
    }
  },
  [PRODUCT_NAMES.NEXULTRA_2]: {
    title: 'yourRoutine.product.nexultra2.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultra2.subtitle',
    subtitleRecommended: {
      [SERUM_USAGES.MORNING_ONLY]: 'yourRoutine.product.yourDayNexultra2.subtitle',
      [SERUM_USAGES.EVENING_ONLY]: 'yourRoutine.product.yourNightNexultra2.subtitle',
      [SERUM_USAGES.MORNING_AND_EVENING]: 'yourRoutine.product.yourDayAndNightNexultra2.subtitle'
    }
  },
  [PRODUCT_NAMES.NEXULTRA_3]: {
    title: 'yourRoutine.product.nexultra3.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultra3.subtitle',
    subtitleRecommended: {
      [SERUM_USAGES.MORNING_ONLY]: 'yourRoutine.product.yourDayNexultra3.subtitle',
      [SERUM_USAGES.EVENING_ONLY]: 'yourRoutine.product.yourNightNexultra3.subtitle',
      [SERUM_USAGES.MORNING_AND_EVENING]: 'yourRoutine.product.yourDayAndNightNexultra3.subtitle'
    }
  },
  [PRODUCT_NAMES.NEXULTRA_B]: {
    title: 'yourRoutine.product.nexultraB.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultraB.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourNexultraB.subtitle',
    sizeOptions: [30, 100]
  },
  [PRODUCT_NAMES.GEL]: {
    title: 'yourRoutine.product.gel.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.gel.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourGel.subtitle',
    sizeOptions: [30, 100]
  },
  [PRODUCT_NAMES.SUNSCREEN_FLD]: {
    title: 'yourRoutine.product.sunscreenFluidSpf50.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.sunscreenFluidSpf50.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourSunscreenFluidSpf50.subtitle'
  },
  [PRODUCT_NAMES.NEXULTRA_L]: {
    title: 'yourRoutine.product.nexultraL.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultraL.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourNexultraL.subtitle',
    sizeOptions: [50, 75]
  },
  [PRODUCT_NAMES.SUNSCREEN_SPF]: {
    title: 'yourRoutine.product.sunscreenSPF.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.yourSunscreenSPF.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourSunscreenSPF.subtitle'
  },
   [PRODUCT_NAMES.SUNSCREEN_CRM]: {
    title: 'yourRoutine.product.sunscreenCRM.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.yourSunscreenCRM.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourSunscreenCRM.subtitle'
  },
  [PRODUCT_NAMES.NEXULTRA_UV]: {
    title: 'yourRoutine.product.nexultraUV.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultraUV.subtitle',
    subtitleRecommended: 'yourRoutine.product.yourNexultraUV.subtitle'
  },
 [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: {
    title: 'yourRoutine.product.nexultraPLight.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultraPLight.subtitle',
    subtitleRecommended: {
      [SERUM_USAGES.MORNING_ONLY]: 'yourRoutine.product.yourDayNexultraPLight.subtitle',
      [SERUM_USAGES.EVENING_ONLY]: 'yourRoutine.product.yourNightNexultraPLight.subtitle',
      [SERUM_USAGES.MORNING_AND_EVENING]:
        'yourRoutine.product.yourDayAndNightNexultraPLight.subtitle'
    }
  },
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: {
    title: 'yourRoutine.product.nexultraPRich.title',
    titleRecommended: null,
    subtitle: 'yourRoutine.product.nexultraPRich.subtitle',
    subtitleRecommended: {
      [SERUM_USAGES.MORNING_ONLY]: 'yourRoutine.product.yourDayNexultraPRich.subtitle',
      [SERUM_USAGES.EVENING_ONLY]: 'yourRoutine.product.yourNightNexultraPRich.subtitle',
      [SERUM_USAGES.MORNING_AND_EVENING]:
        'yourRoutine.product.yourDayAndNightNexultraPRich.subtitle'
    }
  },
  [PRODUCT_NAMES.FREE_SAMPLE]: {
    title: 'product.freeSample.title',
    titleRecommended: null,
    subtitle: 'product.freeSample.subtitle',
    subtitleRecommended: null
  }
};

const YOUR_ROUTINE_FILTER_CATEGORY = {
  ALL: 'all',
  RECOMMENDED: 'recommended',
  CLEANSE: 'cleanse',
  TREAT: 'treat',
  MOISTURIZE: 'moisturize',
  PROTECT: 'protect'
};

const FILTER_CONFIG = {
  [YOUR_ROUTINE_FILTER_CATEGORY.ALL]: {
    value: YOUR_ROUTINE_FILTER_CATEGORY.ALL,
    labelKey: 'section.yourRoutine.productSections.shopAllLabel'
  },
  [YOUR_ROUTINE_FILTER_CATEGORY.RECOMMENDED]: {
    value: YOUR_ROUTINE_FILTER_CATEGORY.RECOMMENDED,
    labelKey: 'section.yourRoutine.productSections.drSelectionLabel'
  },
  [YOUR_ROUTINE_FILTER_CATEGORY.CLEANSE]: {
    value: YOUR_ROUTINE_FILTER_CATEGORY.CLEANSE,
    labelKey: 'section.yourRoutine.productSections.cleanseLabel'
  },
  [YOUR_ROUTINE_FILTER_CATEGORY.TREAT]: {
    value: YOUR_ROUTINE_FILTER_CATEGORY.TREAT,
    labelKey: 'section.yourRoutine.productSections.treatLabel'
  },
  [YOUR_ROUTINE_FILTER_CATEGORY.MOISTURIZE]: {
    value: YOUR_ROUTINE_FILTER_CATEGORY.MOISTURIZE,
    labelKey: 'section.yourRoutine.productSections.moisturizeLabel'
  },
  [YOUR_ROUTINE_FILTER_CATEGORY.PROTECT]: {
    value: YOUR_ROUTINE_FILTER_CATEGORY.PROTECT,
    labelKey: 'section.yourRoutine.productSections.protectLabel'
  }
};

export {
  YOUR_ROUTINE_PRODUCTS_PER_SUBSECTION_DEFAULT,
  YOUR_ROUTINE_SUBSECTION_NAMES,
  PRODUCTS_CONFIGURATION,
  CART_PRODUCT_IMAGES,
  YOUR_ROUTINE_FILTER_CATEGORY,
  FILTER_CONFIG
};
